// extracted by mini-css-extract-plugin
module.exports = {"largeInput":"style_largeInput__QEJPc"};